var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a158769e6e01c3b6f4195abef69a013e.js').default;export default
        Object.assign({}, scope_0 )
    